import { CalendarDate } from '@internationalized/date';
import { RangeValue } from '@react-types/shared';

import generateRange from '../../../../helpers/array/range';
import Row from '../../../Row/Row';
import Mode from '../../types/Mode';
import CalendarGrid from '../CalendarGrid/CalendarGrid';
import CalendarHeader from '../CalendarHeader/CalendarHeader';
import CalendarHeading from '../CalendarHeading/CalendarHeading';
import ClickableCalendarHeading from '../ClickableCalendarHeading/ClickableCalendarHeading';

type DateViewProps = {
    visibleRange: RangeValue<CalendarDate>;
    timeZone: string;
    visibleMonths: number;
    selectingNewRange?: boolean;
    mode?: Mode;
    onHeadingClick?: () => void;
    showDatesOutsideMonth?: boolean;
};

const DateView = ({
    visibleMonths,
    timeZone,
    visibleRange,
    selectingNewRange,
    mode,
    onHeadingClick,
    showDatesOutsideMonth,
}: DateViewProps) => {
    return (
        <div>
            <CalendarHeader>
                {onHeadingClick ? (
                    <ClickableCalendarHeading
                        timeZone={timeZone}
                        visibleRange={visibleRange}
                        onClick={onHeadingClick}
                    />
                ) : (
                    <CalendarHeading
                        visibleRange={visibleRange}
                        timeZone={timeZone}
                    />
                )}
            </CalendarHeader>
            <Row space="xlarge">
                {generateRange(1, visibleMonths).map((monthIndex) => (
                    <CalendarGrid
                        key={monthIndex}
                        offset={{ months: monthIndex - 1 }}
                        selectingNewRange={selectingNewRange}
                        mode={mode}
                        showDatesOutsideMonth={showDatesOutsideMonth}
                    />
                ))}
            </Row>
        </div>
    );
};

export default DateView;
